import UserInfoBanner from "./UserInfoBanner";
export default UserInfoBanner;